import { Injectable } from '@angular/core';
import {
  Observable,
  BehaviorSubject,
  Subscription,
  AsyncSubject,
  of,
} from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AddOfferModel } from '../interfaces/interfaces';
import { BACKEND_URL } from '../helpers/constants';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as S3 from 'aws-sdk/clients/s3';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class OfferDataService {
  private ADD_OFFER_URL = `${BACKEND_URL}/offers/addOffer`;
  constructor(private http: HttpClient) {}

  uploadOfferImageData(file: any, key: string): Observable<string> {
    let offerImageSubject = new AsyncSubject<string>();
    if (file != null) {
      const bucket = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
      const params = {
        Bucket: 'stotrasagar-offer-images',
        Key: key,
        Body: file,
        ACL: 'public-read',
        ContentType: file.type,
      };

      bucket.upload(params, async (err: any, data: any) => {
        if (err == null) {
          offerImageSubject.next(data.Location);
        } else {
          offerImageSubject.next('error');
        }
        offerImageSubject.complete();
      });
      return offerImageSubject.asObservable();
    } else {
      offerImageSubject.next('');
      offerImageSubject.complete();
      return offerImageSubject.asObservable();
    }
  }

  addOfferData(addOffer: AddOfferModel) {
    return this.http.post(this.ADD_OFFER_URL, addOffer);
  }
}
